/**
 *
 * Main reducer
 *
 */

import { fromJS, Map } from 'immutable';

import {
  GET_SETTINGS_SUCCEEDED,
  ON_CHANGE_CONTENT_TYPES,
  SUBMIT_MODAL,
  GET_CONTENT_TYPES_SUCCEEDED,
  GET_LANGUAGES_SUCCEEDED,
  DELETE_CONTENT_TYPE,
  DELETE_CUSTOM_ENTRY,
  DISCARD_ALL_CHANGES,
  DISCARD_MODIFIED_CONTENT_TYPES,
  ON_SUBMIT_SUCCEEDED,
  ON_CHANGE_SETTINGS,
  UPDATE_SETTINGS,
  GET_SITEMAP_INFO_SUCCEEDED,
  ON_CHANGE_CUSTOM_ENTRY,
  GET_ALLOWED_FIELDS_SUCCEEDED,
  SET_LOADING_STATE,
  GET_SITEMAPS_SUCCEEDED,
  PREPARE_SETTINGS_FORM,
} from '../../../config/constants';

const initialState = fromJS({
  loading: false,
  info: {},
  sitemaps: [],
  allowedFields: {},
  settings: Map({}),
  contentTypes: {},
  languages: [],
  initialData: Map({}),
  modifiedContentTypes: Map({}),
  modifiedCustomEntries: Map({}),
});

// eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
export default function sitemapReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SETTINGS_SUCCEEDED:
      return state
        .update('settings', () => fromJS(action.settings));
    case PREPARE_SETTINGS_FORM:
      return state
        .update('initialData', () => fromJS(action.settings))
        .updateIn(['initialData', 'contentTypes'], () => fromJS(action.settings.get('contentTypes')))
        .updateIn(['initialData', 'customEntries'], () => fromJS(action.settings.get('customEntries')))
        .update('modifiedContentTypes', () => fromJS(action.settings.get('contentTypes')))
        .update('modifiedCustomEntries', () => fromJS(action.settings.get('customEntries')));
    case UPDATE_SETTINGS:
      return state
        .update('modifiedContentTypes', () => fromJS(action.settings.get('contentTypes')))
        .updateIn(['settings', 'contentTypes'], () => fromJS(action.settings.get('contentTypes')));
    case ON_CHANGE_CONTENT_TYPES:
      if (action.lang) {
        return state
          .updateIn(['modifiedContentTypes', action.contentType, 'languages', action.lang, action.key], () => action.value);
      }
      return state
        .updateIn(['modifiedContentTypes', action.contentType, action.key], () => action.value);
    case ON_CHANGE_CUSTOM_ENTRY:
      return state
        .updateIn(['modifiedCustomEntries', action.url, action.key], () => action.value);
    case ON_CHANGE_SETTINGS:
      return state
        .updateIn(['settings', 'sitemaps', action.id, action.key], () => fromJS(action.value));
    case DISCARD_ALL_CHANGES:
      return state
        .updateIn(['settings', 'sitemaps', action.id], () => state.get('initialData'))
        .update('modifiedContentTypes', () => state.getIn(['initialData', 'contentTypes']))
        .update('modifiedCustomEntries', () => state.getIn(['initialData', 'customEntries']));
    case DISCARD_MODIFIED_CONTENT_TYPES:
      return state
        .update('modifiedContentTypes', () => state.getIn(['settings', 'sitemaps', action.id, 'contentTypes']))
        .update('modifiedCustomEntries', () => state.getIn(['settings', 'sitemaps', action.id, 'customEntries']));
    case SUBMIT_MODAL:
      return state
        .updateIn(['settings', 'sitemaps', action.id, 'contentTypes'], () => state.get('modifiedContentTypes'))
        .updateIn(['settings', 'sitemaps', action.id, 'customEntries'], () => state.get('modifiedCustomEntries'));
    case DELETE_CONTENT_TYPE:
      if (state.getIn(['settings', 'sitemaps', action.id, 'contentTypes', action.key, 'languages']).size > 1) {
        return state
          .deleteIn(['settings', 'sitemaps', action.id, 'contentTypes', action.key, 'languages', action.lang])
          .deleteIn(['modifiedContentTypes', action.key, 'languages', action.lang]);
      }
      return state
        .deleteIn(['settings', 'sitemaps', action.id, 'contentTypes', action.key])
        .deleteIn(['modifiedContentTypes', action.key]);
    case DELETE_CUSTOM_ENTRY:
      return state
        .deleteIn(['settings', 'sitemaps', action.id, 'customEntries', action.key])
        .deleteIn(['modifiedCustomEntries', action.key]);
    case GET_CONTENT_TYPES_SUCCEEDED:
      return state
        .update('contentTypes', () => action.contentTypes);
    case GET_LANGUAGES_SUCCEEDED:
      return state
        .update('languages', () => action.languages);
    case GET_SITEMAPS_SUCCEEDED:
      return state
        .update('sitemaps', () => fromJS(action.sitemaps));
    case ON_SUBMIT_SUCCEEDED:
      return state
        .update('initialData', () => state.getIn(['settings', 'sitemaps', action.id]));
    case GET_SITEMAP_INFO_SUCCEEDED:
      return state
        .update('info', () => fromJS(action.info));
    case GET_ALLOWED_FIELDS_SUCCEEDED:
      return state
        .update('allowedFields', () => action.fields);
    case SET_LOADING_STATE:
      return state
        .update('loading', () => action.loading);
    default:
      return state;
  }
}
